<template>
  <div class="wrap">
    <img class="banner" src="../../assets/images/signResult.png" alt />
    <p class="desc">签约成功</p>
    <van-button v-if="platform=='ios'" class="btn red" @click="toClose">关闭</van-button>
    <a v-if="platform=='android'" href="ymrjapp://startapp/open"  class="btn black">打开APP</a>
    <p v-if="platform=='android'" class="tips">若不能直接返回APP，请自行手动返回</p>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageType:'',
        platform:'',
      };
    },
    methods: {
      toClose(){
        if(this.pageType=='app'){
          let data={
            command:'back',
            payload:{
              webView:'CashOut'
            },
          };
          window.postMessage(JSON.stringify(data),'*');
        }
      },
      getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
    },
    mounted() {
      document.title = '签约成功';
      let type = this.getUrlParam("type");
      let platform = this.getUrlParam("platform");
      this.pageType = type
      this.platform = platform
    }
  };
</script>

<style scoped>
  .wrap {
    width: 100%;
    background: #fff;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1.5rem;
    box-sizing: border-box;
  }
  .banner{
    width: 1.5rem;
    height: 1.54rem;
    margin-bottom: .34rem;
  }
  .desc{
    height: .42rem;
    line-height: .42rem;
    margin-bottom: .8rem;
    font-size: .3rem;
    color: #333;
    font-weight: 500;
  }
  .btn {
    display: block;
    width: 3.3rem;
    height: 0.76rem;
    border-radius: 0.38rem;
    font-size: 0.3rem;
    font-weight: 500;
    text-align: center;
    line-height: .76rem;
    border: 0;
    box-sizing: border-box;
  }
  .btn.red {
    border: 1px solid #e52b25;
    color: #e52b25;
  }
  .btn.black{
    border: 1px solid #000;
    color: #000;
  }
  .tips{
    height: .3rem;
    line-height: .3rem;
    margin-top: .25rem;
    font-size: .22rem;
    color: #999;
    font-weight: 500;
  }
</style>


// WEBPACK FOOTER //
// src/components/information/signResult.vue